import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Sparkle } from "../components/Decor2";
import { WavyBreak, WavyCard } from "../components/Wavy";

const TILE_COLOURS = ["#FFC2D1", "#4ECDE9", "#FFD23F", "#C39EE3", "#FF7A3D", "#EC2675"];

const Gallery = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="bg-cream">
      <section className="relative pt-10 md:pt-16 pb-10 px-6 md:px-10 text-center overflow-hidden">
        <Sparkle className="absolute top-16 left-14 w-6 h-6" color="#EC2675" />
        <Sparkle className="absolute top-24 right-20 w-5 h-5" color="#4ECDE9" />
        <span className="font-serif-display uppercase tracking-[0.3em] text-magenta text-[11px] md:text-sm font-semibold">MADE IN THE FOUNDRY</span>
        <h1 className="font-serif-display uppercase text-plum-deep text-4xl sm:text-5xl lg:text-6xl mt-4" data-testid="gallery-title">GALLERY</h1>
      </section>

      <WavyBreak color="#EC2675" />

      <section className="px-6 md:px-10 pb-24 max-w-[1400px] mx-auto">
        {items === null ? (
          <p className="text-center text-plum-deep/60 py-16">Loading gallery…</p>
        ) : items.length === 0 ? (
          <p className="text-center text-plum-deep/60 py-16" data-testid="gallery-empty">Nothing here yet — check back soon!</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14 mt-8" data-testid="gallery-grid">
            {items.map((item, i) => (
              <figure key={item.id} className="text-center group" data-testid={`gallery-item-${i}`}>
                <WavyCard
                  src={item.image_url}
                  alt={item.caption || "Gallery image"}
                  bg={TILE_COLOURS[i % TILE_COLOURS.length]}
                  className="transition-transform duration-500 group-hover:-rotate-2"
                />
                {item.caption && (
                  <figcaption className="mt-5 font-serif-display uppercase text-plum-deep text-xl tracking-[0.1em]">
                    {item.caption}
                  </figcaption>
                )}
              </figure>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Gallery;
